var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{attrs:{"id":"titulo"}},[_vm._v(" "+_vm._s(_vm.contents)),_c('SvgIcon',{staticClass:"wave",attrs:{"data":require("@svgs/wave.svg"),"original":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }